/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
/** DISPLAY NAME: &lt;ListGroup.Template&gt; */
// NOTE: Props are used by the parent. Do NOT remove any unused props!!!!!!
var ListGroupTemplate = function (_a) {
    var checkbox = _a.checkbox, children = _a.children, collapsible = _a.collapsible, itemsKey = _a.itemsKey, titleKey = _a.titleKey, _b = _a.__TYPE, __TYPE = _b === void 0 ? 'ListGroupTemplate' : _b;
    return React.createElement("div", null, "template");
};
ListGroupTemplate.defaultProps = {
    checkbox: false,
    collapsible: true,
    __TYPE: 'ListGroupTemplate',
};
export default ListGroupTemplate;
